import { createStore } from "vuex";
import store2 from "store2";
import moment from "moment";
let local_storage = store2.namespace("cedm");

function initialState() {
    return {
        statusIncident: {
            base: { isComplete: false, lastStudyTime: "" },
            story: { isComplete: false, lastStudyTime: "" },
            test: { isComplete: false, lastStudyTime: "" },
            isComplete: false,
            lastStudyTime: "",
        },
        statusInformation: {
            base: { isComplete: false, lastStudyTime: "" },
            story: { isComplete: false, lastStudyTime: "" },
            test: { isComplete: false, lastStudyTime: "" },
            isComplete: false,
            lastStudyTime: "",
        },
        statusMail: {
            base: { isComplete: false, lastStudyTime: "" },
            story: { isComplete: false, lastStudyTime: "" },
            test: { isComplete: false, lastStudyTime: "" },
            isComplete: false,
            lastStudyTime: "",
        },
        statusPswd: {
            base: { isComplete: false, lastStudyTime: "" },
            story: { isComplete: false, lastStudyTime: "" },
            test: { isComplete: false, lastStudyTime: "" },
            isComplete: false,
            lastStudyTime: "",
        },
        statusWeb: {
            base: { isComplete: false, lastStudyTime: "" },
            story: { isComplete: false, lastStudyTime: "" },
            test: { isComplete: false, lastStudyTime: "" },
            isComplete: false,
            lastStudyTime: "",
        },
    };
}

// Create a new store instance.
const store = createStore({
    state: initialState(),
    getters: {
        getStatusIncident: (state) => () => {
            return state.statusIncident;
        },
        getStatusInformation: (state) => () => {
            return state.statusInformation;
        },
        getStatusMail: (state) => () => {
            return state.statusMail;
        },
        getStatusPassword: (state) => () => {
            return state.statusPswd;
        },
        getStatusWeb: (state) => () => {
            return state.statusWeb;
        },
    },
    mutations: {
        setCache(state) {
            let loaded = local_storage.getAll();
            if (!Object.keys(loaded).length) {
                loaded = initialState();
                local_storage.setAll(loaded);
            }
            Object.keys(loaded).forEach((key) => {
                if (key in state) {
                    state[key] = loaded[key];
                }
            });
        },
        clearCache(state) {
            state = initialState();
            local_storage.setAll(state);
            window.location = "/cedm";
        },
        setLastTime(state, payload) {
            state[`status${payload.contents}`][payload.page][
                `lastStudyTime`
            ] = moment().format("YYYY/MM/DD HH:mm:ss");
            local_storage.transact(`status${payload.contents}`, (v) => {
                v[payload.page][`lastStudyTime`] = moment().format(
                    "YYYY/MM/DD HH:mm:ss"
                );
            });
            local_storage.transact(`status${payload.contents}`, (v) => {
                v.lastStudyTime = moment().format("YYYY/MM/DD HH:mm:ss");
            });
        },
        setCompleteStatus(state, payload) {
            state[`status${payload.contents}`][payload.page][`isComplete`] =
                payload.isComplete;
            local_storage.transact(`status${payload.contents}`, (v) => {
                v[payload.page][`isComplete`] = payload.isComplete;
            });
        },
        setContentsCompleteStatus(state, payload) {
            state[`status${payload.contents}`][`isComplete`] =
                payload.isComplete;
            local_storage.transact(`status${payload.contents}`, (v) => {
                v.isComplete = payload.isComplete;
            });
        },
    },
});

export default store;
